'use client';

import dynamic from 'next/dynamic';
import { Breadcrumbs as BreadcrumbsComponent } from '@/app/components/breadcrumbs/index';
import { FullscreenSkeleton } from './skeleton/skeleton';
import { getText } from '@/utils/text/text';
import './styles/default.scss';

const VideoListComponent = dynamic(() => import('./video-list/video-list').then((mod) => mod.VideoListComponent), {
    ssr: false,
    loading: () => <FullscreenSkeleton />
});

type GameData = {
    trailerUrl?: string;
    gameKey?: string;
    [key: string]: unknown;
};

type ExploreVideosProps = {
    categoryName?: string;
    categoryUid?: string;
    content?: Array<{
        data?: {
            game_play_trailer?:
                | string
                | {
                      url?: string;
                  };
        };
    }>;
    gamesData?: GameData[];
};

export const ExploreVideos = ({ categoryName = '', categoryUid, content = [], gamesData = [] }: ExploreVideosProps) => {
    const hasGames = content.length >= 2;
    const pageBreadcrumbs = [{ label: categoryName }];

    const renderNoGames = () => {
        return (
            <>
                <div className="breadcrumbs-container">
                    <BreadcrumbsComponent links={pageBreadcrumbs} />
                </div>
                <div className="no-category-games">
                    <div className="no-category-games-title">{categoryName}</div>
                    <span className="no-category-games-message">
                        {getText({ text: 'components.noGamesAvailable' })}
                    </span>
                </div>
            </>
        );
    };

    if (!hasGames) {
        return (
            <div className="explore-videos-container" data-t-categoryuid={categoryUid}>
                {renderNoGames()}
            </div>
        );
    }

    return (
        <div className="explore-videos-container" data-t-categoryuid={categoryUid}>
            <VideoListComponent gamesData={gamesData} />
        </div>
    );
};
